import React, { useRef } from 'react';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import classNames from 'classnames';
import FullScreenImage from '@/components/reusable/FullScreenImage/FullScreenImage';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import './NewSpaceCardRedesignDetailVersion.scss';

const NewSpaceCardRedesignDetailVersion = (props) => {
  const { spaceInfo, handleDetailButton } = props;
  const imageRef = useRef();
  const containerClass = classNames(
    'NewSpaceCardDetailVersion flex-column format100 border-rad16px',
  );
  const imageItemStyle = { height: '400px', objectFit: 'cover' };
  const mobileImageItemStyle = { width: '100%', height: '400px', objectFit: 'cover' };

  const imagesArray = (() => {
    try {
      const parsed =
        spaceInfo?.url_img && spaceInfo?.url_img !== null
          ? JSON.parse(spaceInfo?.url_img)
          : JSON.parse(spaceInfo?.main_image);
      return Array.isArray(parsed) && parsed.length > 0
        ? parsed
        : [spaceInfo?.main_image].filter(Boolean);
    } catch {
      return [spaceInfo?.main_image].filter(Boolean);
    }
  })();

  const handleClickImage = (path) => {
    imageRef.current.showImage(path);
  };

  return (
    <FlexContainer className={containerClass} onClick={handleDetailButton}>
      <FullScreenImage ref={imageRef} />
      <FlexContainer className={'width100 d-hide margb20 border-rad8px'}>
        <Swiper
          loop={true}
          autoplay={{
            delay: 10500,
            disableOnInteraction: true,
          }}
          pagination={{
            clickable: true,
          }}
          modules={[Autoplay, Pagination]}
          spaceBetween={30}
          slidesPerView={1}
        >
          {imagesArray.map((image, index) => (
            <SwiperSlide key={index}>
              <img
                src={image}
                className={'border-rad8px'}
                alt={spaceInfo?.space_title}
                style={{ ...mobileImageItemStyle, width: '100%' }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </FlexContainer>

      <FlexContainer className={'width100 m-hide margb20 border-rad8px'}>
        {imagesArray.length === 1 && (
          <img
            src={imagesArray[0]}
            className={'border-rad8px'}
            alt={spaceInfo?.space_title}
            style={{ ...mobileImageItemStyle, width: '100%' }}
            onClick={() => handleClickImage(imagesArray[0])}
          />
        )}
        {imagesArray.length === 2 && (
          <FlexContainer className={'width100 gap-10'}>
            <img
              src={imagesArray[0]}
              className={'border-rad8px'}
              alt={spaceInfo?.space_title}
              style={{ ...mobileImageItemStyle, width: '50%' }}
              onClick={() => handleClickImage(imagesArray[0])}
            />
            <img
              src={imagesArray[1]}
              className={'border-rad8px'}
              alt={spaceInfo?.space_title}
              style={{ ...mobileImageItemStyle, width: '50%' }}
              onClick={() => handleClickImage(imagesArray[1])}
            />
          </FlexContainer>
        )}
        {imagesArray.length === 3 && (
          <FlexContainer className={'width100 gap-10'}>
            <img
              src={imagesArray[0]}
              className={'border-rad8px'}
              alt={spaceInfo?.space_title}
              style={{ ...mobileImageItemStyle, width: '75%' }}
              onClick={() => handleClickImage(imagesArray[0])}
            />
            <FlexContainer className={'width100 flex-column gap-10'}>
              <img
                src={imagesArray[1]}
                className={'border-rad8px'}
                alt={spaceInfo?.space_title}
                style={{ height: '195px', objectFit: 'cover', width: '100%' }}
                onClick={() => handleClickImage(imagesArray[1])}
              />
              <img
                src={imagesArray[2]}
                className={'border-rad8px'}
                alt={spaceInfo?.space_title}
                style={{ height: '195px', objectFit: 'cover', width: '100%' }}
                onClick={() => handleClickImage(imagesArray[2])}
              />
            </FlexContainer>
          </FlexContainer>
        )}
        {imagesArray.length === 4 && (
          <FlexContainer className={'width100 gap-10'}>
            <img
              src={imagesArray[0]}
              className={'border-rad8px'}
              alt={spaceInfo?.space_title}
              style={{ ...mobileImageItemStyle, width: '75%' }}
              onClick={() => handleClickImage(imagesArray[0])}
            />
            <FlexContainer className={'width100 flex-column gap-10'}>
              <img
                src={imagesArray[1]}
                className={'border-rad8px'}
                alt={spaceInfo?.space_title}
                style={{ height: '126.67px', objectFit: 'cover', width: '100%' }}
                onClick={() => handleClickImage(imagesArray[1])}
              />
              <img
                src={imagesArray[2]}
                className={'border-rad8px'}
                alt={spaceInfo?.space_title}
                style={{ height: '126.67px', objectFit: 'cover', width: '100%' }}
                onClick={() => handleClickImage(imagesArray[2])}
              />
              <img
                src={imagesArray[3]}
                className={'border-rad8px'}
                alt={spaceInfo?.space_title}
                style={{ height: '126.67px', objectFit: 'cover', width: '100%' }}
                onClick={() => handleClickImage(imagesArray[3])}
              />
            </FlexContainer>
          </FlexContainer>
        )}
        {imagesArray.length === 5 && (
          <FlexContainer className={'width100 gap-10'}>
            <img
              src={imagesArray[0]}
              className={'border-rad8px'}
              alt={spaceInfo?.space_title}
              style={{ ...mobileImageItemStyle, width: '75%' }}
              onClick={() => handleClickImage(imagesArray[0])}
            />
            <FlexContainer className={'format30 flex-column gap-10'}>
              <img
                src={imagesArray[1]}
                className={'border-rad8px'}
                alt={spaceInfo?.space_title}
                style={{ height: '92.5px', objectFit: 'cover', width: '100%' }}
                onClick={() => handleClickImage(imagesArray[1])}
              />
              <img
                src={imagesArray[2]}
                className={'border-rad8px'}
                alt={spaceInfo?.space_title}
                style={{ height: '92.5px', objectFit: 'cover', width: '100%' }}
                onClick={() => handleClickImage(imagesArray[2])}
              />
              <img
                src={imagesArray[3]}
                className={'border-rad8px'}
                alt={spaceInfo?.space_title}
                style={{ height: '92.5px', objectFit: 'cover', width: '100%' }}
                onClick={() => handleClickImage(imagesArray[3])}
              />
              <img
                src={imagesArray[4]}
                className={'border-rad8px'}
                alt={spaceInfo?.space_title}
                style={{ height: '92.5px', objectFit: 'cover', width: '100%' }}
                onClick={() => handleClickImage(imagesArray[4])}
              />
            </FlexContainer>
          </FlexContainer>
        )}
        {imagesArray.length === 6 && (
          <FlexContainer className={'width100 gap-10'}>
            <img
              src={imagesArray[0]}
              className={'border-rad8px'}
              alt={spaceInfo?.space_title}
              style={{ ...mobileImageItemStyle, width: '75%' }}
              onClick={() => handleClickImage(imagesArray[0])}
            />
            <FlexContainer className={'format30 flex-column gap-10'}>
              <img
                src={imagesArray[1]}
                className={'border-rad8px'}
                alt={spaceInfo?.space_title}
                style={{ height: '92.5px', objectFit: 'cover', width: '100%' }}
                onClick={() => handleClickImage(imagesArray[1])}
              />
              <img
                src={imagesArray[2]}
                className={'border-rad8px'}
                alt={spaceInfo?.space_title}
                style={{ height: '92.5px', objectFit: 'cover', width: '100%' }}
                onClick={() => handleClickImage(imagesArray[2])}
              />
              <img
                src={imagesArray[3]}
                className={'border-rad8px'}
                alt={spaceInfo?.space_title}
                style={{ height: '92.5px', objectFit: 'cover', width: '100%' }}
                onClick={() => handleClickImage(imagesArray[3])}
              />
              <img
                src={imagesArray[4]}
                className={'border-rad8px'}
                alt={spaceInfo?.space_title}
                style={{ height: '92.5px', objectFit: 'cover', width: '100%' }}
                onClick={() => handleClickImage(imagesArray[4])}
              />
            </FlexContainer>
          </FlexContainer>
        )}
        {imagesArray.length === 7 && (
          <FlexContainer className={'width100'}>
            <img
              src={imagesArray[0]}
              className={'border-rad8px'}
              alt={spaceInfo?.space_title}
              style={imageItemStyle}
              onClick={() => handleClickImage(imagesArray[0])}
            />
            <img
              src={imagesArray[1]}
              className={'border-rad8px'}
              alt={spaceInfo?.space_title}
              style={imageItemStyle}
              onClick={() => handleClickImage(imagesArray[1])}
            />
            <img
              src={imagesArray[2]}
              className={'border-rad8px'}
              alt={spaceInfo?.space_title}
              style={imageItemStyle}
              onClick={() => handleClickImage(imagesArray[2])}
            />
            <img
              src={imagesArray[3]}
              className={'border-rad8px'}
              alt={spaceInfo?.space_title}
              style={imageItemStyle}
              onClick={() => handleClickImage(imagesArray[3])}
            />
            <img
              src={imagesArray[4]}
              className={'border-rad8px'}
              alt={spaceInfo?.space_title}
              style={imageItemStyle}
              onClick={() => handleClickImage(imagesArray[4])}
            />
            <img
              src={imagesArray[5]}
              className={'border-rad8px'}
              alt={spaceInfo?.space_title}
              style={imageItemStyle}
              onClick={() => handleClickImage(imagesArray[5])}
            />
          </FlexContainer>
        )}
        {imagesArray.length === 8 && (
          <FlexContainer className={'flex-column width100 gap-10'}>
            <FlexContainer className={'width100 gap-10'}>
              <img
                src={imagesArray[0]}
                className={'border-rad8px'}
                alt={spaceInfo?.space_title}
                style={{ height: '300px', objectFit: 'cover', width: '75%' }}
                onClick={() => handleClickImage(imagesArray[0])}
              />
              <FlexContainer className={'format30 flex-column gap-10'}>
                <img
                  src={imagesArray[1]}
                  className={'border-rad8px'}
                  alt={spaceInfo?.space_title}
                  style={{ height: '93.34px', objectFit: 'cover', width: '100%' }}
                  onClick={() => handleClickImage(imagesArray[1])}
                />
                <img
                  src={imagesArray[2]}
                  className={'border-rad8px'}
                  alt={spaceInfo?.space_title}
                  style={{ height: '93.34px', objectFit: 'cover', width: '100%' }}
                  onClick={() => handleClickImage(imagesArray[2])}
                />
                <img
                  src={imagesArray[3]}
                  className={'border-rad8px'}
                  alt={spaceInfo?.space_title}
                  style={{ height: '93.34px', objectFit: 'cover', width: '100%' }}
                  onClick={() => handleClickImage(imagesArray[3])}
                />
              </FlexContainer>
            </FlexContainer>
            <FlexContainer className={'width100 gap-10'}>
              <img
                src={imagesArray[4]}
                className={'border-rad8px'}
                alt={spaceInfo?.space_title}
                style={{ height: '90px', objectFit: 'cover', width: '100%' }}
                onClick={() => handleClickImage(imagesArray[4])}
              />
              <img
                src={imagesArray[5]}
                className={'border-rad8px'}
                alt={spaceInfo?.space_title}
                style={{ height: '90px', objectFit: 'cover', width: '100%' }}
                onClick={() => handleClickImage(imagesArray[5])}
              />
              <img
                src={imagesArray[6]}
                className={'border-rad8px'}
                alt={spaceInfo?.space_title}
                style={{ height: '90px', objectFit: 'cover', width: '100%' }}
                onClick={() => handleClickImage(imagesArray[6])}
              />
              <img
                src={imagesArray[7]}
                className={'border-rad8px'}
                alt={spaceInfo?.space_title}
                style={{ height: '90px', objectFit: 'cover', width: '100%' }}
                onClick={() => handleClickImage(imagesArray[7])}
              />
            </FlexContainer>
          </FlexContainer>
        )}
        {imagesArray.length === 11 && (
          <FlexContainer className={'flex-column width100 gap-10'}>
            <FlexContainer className={'width100 gap-10'}>
              <img
                src={imagesArray[0]}
                className={'border-rad8px format90'}
                alt={spaceInfo?.space_title}
                style={{ height: '320px', objectFit: 'cover' }}
                onClick={() => handleClickImage(imagesArray[0])}
              />
              <FlexContainer className={'format20 flex-column gap-10'}>
                <img
                  src={imagesArray[1]}
                  className={'border-rad8px'}
                  alt={spaceInfo?.space_title}
                  style={{ height: '56px', objectFit: 'cover', width: '100%' }}
                  onClick={() => handleClickImage(imagesArray[1])}
                />
                <img
                  src={imagesArray[2]}
                  className={'border-rad8px'}
                  alt={spaceInfo?.space_title}
                  style={{ height: '56px', objectFit: 'cover', width: '100%' }}
                  onClick={() => handleClickImage(imagesArray[2])}
                />
                <img
                  src={imagesArray[3]}
                  className={'border-rad8px'}
                  alt={spaceInfo?.space_title}
                  style={{ height: '56px', objectFit: 'cover', width: '100%' }}
                  onClick={() => handleClickImage(imagesArray[3])}
                />
                <img
                  src={imagesArray[4]}
                  className={'border-rad8px'}
                  alt={spaceInfo?.space_title}
                  style={{ height: '56px', objectFit: 'cover', width: '100%' }}
                  onClick={() => handleClickImage(imagesArray[4])}
                />
                <img
                  src={imagesArray[5]}
                  className={'border-rad8px'}
                  alt={spaceInfo?.space_title}
                  style={{ height: '56px', objectFit: 'cover', width: '100%' }}
                  onClick={() => handleClickImage(imagesArray[5])}
                />
              </FlexContainer>
            </FlexContainer>
            <FlexContainer className={'width100 gap-10'}>
              <img
                src={imagesArray[6]}
                className={'border-rad8px'}
                alt={spaceInfo?.space_title}
                style={{ height: '70px', objectFit: 'cover', width: '100%' }}
                onClick={() => handleClickImage(imagesArray[6])}
              />
              <img
                src={imagesArray[7]}
                className={'border-rad8px'}
                alt={spaceInfo?.space_title}
                style={{ height: '70px', objectFit: 'cover', width: '100%' }}
                onClick={() => handleClickImage(imagesArray[7])}
              />
              <img
                src={imagesArray[8]}
                className={'border-rad8px'}
                alt={spaceInfo?.space_title}
                style={{ height: '70px', objectFit: 'cover', width: '100%' }}
                onClick={() => handleClickImage(imagesArray[8])}
              />
              <img
                src={imagesArray[9]}
                className={'border-rad8px'}
                alt={spaceInfo?.space_title}
                style={{ height: '70px', objectFit: 'cover', width: '100%' }}
                onClick={() => handleClickImage(imagesArray[9])}
              />
              <img
                src={imagesArray[10]}
                className={'border-rad8px'}
                alt={spaceInfo?.space_title}
                style={{ height: '70px', objectFit: 'cover', width: '100%' }}
                onClick={() => handleClickImage(imagesArray[10])}
              />
            </FlexContainer>
          </FlexContainer>
        )}
      </FlexContainer>
    </FlexContainer>
  );
};

export default NewSpaceCardRedesignDetailVersion;
